import { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';

import { VehicleDetailsSubset } from './ExtractVehicleDetailsSubset';
import { VehicleDetailsEvent } from './VehicleDetailsEvent';
import { vehicleDetailsSchema } from './VehicleDetailsSchema';

export const vehicleToVehicleDetailsEvent = (
  vehicle: Vehicle | VehicleDetailsSubset,
): VehicleDetailsEvent => {
  const event: VehicleDetailsEvent = {
    schema: vehicleDetailsSchema.ref,
    data: {
      bhp: vehicle.spec.bhp!,
      body_type: vehicle.spec.bodyType!,
      co2Gkm: vehicle.spec.co2Gkm!,
      cubic_capacity: vehicle.spec.cubicCapacity ?? undefined,
      doors: vehicle.spec.doors!,
      engine_size: vehicle.spec.engineSize ?? undefined,
      features: vehicle.spec.featureString!,
      first_registration: vehicle.spec.firstRegistrationDate!,
      fuel_consumption: vehicle.spec.fuelConsumption!,
      fuel_type: vehicle.spec.fuelType!,
      gearbox: vehicle.spec.gearbox!,
      insurance_group: vehicle.spec.insuranceGroup!,
      seats: vehicle.spec.seats!,
      ulez: vehicle.spec.ulez!,
      is_new_car: vehicle.details.isNewCar!,
      factory_approved: vehicle.details.isFactoryApproved!,
      previous_owners: vehicle.details.previousOwners!,
      vin: vehicle.vin!,
      listing_id: vehicle.heycarId,
    },
  };

  return event;
};
